(function () {
  var EASE = "cubic-bezier(0.22, 1, 0.36, 1)";
  var root = document.querySelector('[data-yz="product"]');
  if (!root) return;

  var photo = root.querySelector("[data-yz-photo]");
  var dots = root.querySelector("[data-yz-dots]");
  var nameEl = root.querySelector("[data-yz-name]");
  var priceEls = root.querySelectorAll("[data-yz-price], [data-yz-price-open]");
  var sizesEl = root.querySelector("[data-yz-sizes]");
  var descEl = root.querySelector("[data-yz-description]");
  var fitEl = root.querySelector("[data-yz-fit]");
  var noteEl = root.querySelector("[data-yz-note]");
  var catalog = [];
  var imageIndex = 0;
  var photoToken = 0;
  var sliding = false;
  var current = null;
  var selectedColor = "";
  var selectedVariant = null;
  var addBtn = root.querySelector("[data-yz-add]");
  var colorsEl = root.querySelector("[data-yz-colors]");
  var initialWomen = root.dataset.showFit === "1" ? root.dataset.women : "";

  var frame = photo.closest(".yz-photo-frame");
  if (!frame) {
    frame = document.createElement("div");
    frame.className = "yz-photo-frame";
    photo.parentNode.insertBefore(frame, photo);
    frame.appendChild(photo);
  }
  var side = frame.querySelector("[data-yz-photo-side]");
  if (!side) {
    side = document.createElement("img");
    side.className = "yz-photo-side";
    side.alt = "";
    side.setAttribute("aria-hidden", "true");
    side.setAttribute("data-yz-photo-side", "");
    frame.appendChild(side);
  }
  var photoAnimating = false;

  function fitSizeChart() {
    if (!window.matchMedia("(max-width: 749px)").matches || !descEl) return;
    descEl.querySelectorAll("table").forEach(function (table) {
      table.querySelectorAll("td, th").forEach(function (cell) {
        if (cell.colSpan > 1) cell.colSpan = 1;
      });
      table.querySelectorAll("tr").forEach(function (row) {
        var cells = Array.prototype.slice.call(row.cells);
        if (cells.length < 8) return;
        for (var i = cells.length - 1; i >= 2; i--) {
          if (i % 2 === 0) cells[i].remove();
        }
      });
    });
  }

  fitSizeChart();

  function hoistCart() {
    var drawer = document.querySelector("cart-drawer-component");
    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
    return drawer;
  }

  function money(cents) {
    var n = Number(cents) / 100;
    if (!isFinite(n)) return "";
    return n % 1 === 0 ? "$" + n.toFixed(0) : "$" + n.toFixed(2);
  }

  function cents(variant) {
    if (!variant) return 0;
    if (typeof variant.price === "number") return variant.price;
    return Math.round(parseFloat(variant.price) * 100);
  }

  function imagesOf(product) {
    return (product.images || [])
      .map(function (img) {
        if (!img) return "";
        if (typeof img === "string") return img;
        return img.src || "";
      })
      .filter(Boolean);
  }

  function sized(src) {
    if (!src) return "";
    if (src.indexOf("width=") !== -1) return src;
    return src + (src.indexOf("?") === -1 ? "?" : "&") + "width=1400";
  }

  function baseHandle(handle) {
    return /-wmns$/.test(handle) ? handle.replace(/-wmns$/, "") : handle;
  }

  function readInitial() {
    var node = document.querySelector("[data-yz-initial]");
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return null;
    }
  }

  function setPrices(product) {
    var label = money(cents((product.variants || [])[0]));
    priceEls.forEach(function (el) {
      el.textContent = label;
    });
  }

  function renderDots(product) {
    var imgs = imagesOf(product);
    var prev = root.querySelector("[data-yz-prev]");
    var next = root.querySelector("[data-yz-next]");
    var single = imgs.length < 2;
    if (prev) prev.hidden = single;
    if (next) next.hidden = single;
    dots.replaceChildren();
    imgs.forEach(function (_, i) {
      var dot = document.createElement("button");
      dot.type = "button";
      dot.className = "yz-dot" + (i === imageIndex ? " is-active" : "");
      dot.setAttribute("aria-label", "Photo " + (i + 1));
      dot.addEventListener("click", function () {
        if (i === imageIndex || photoAnimating) return;
        var dir = i > imageIndex ? 1 : -1;
        imageIndex = i;
        slidePhoto(imgs[i], dir);
        renderDots(product);
      });
      dots.appendChild(dot);
    });
  }

  function warm(product) {
    imagesOf(product).forEach(function (src) {
      var img = new Image();
      img.src = sized(src);
    });
  }

  function slidePhoto(src, dir) {
    var url = sized(src);
    var width = photo.getBoundingClientRect().width;
    if (!width || photoAnimating) {
      if (!photoAnimating) photo.src = url;
      return;
    }
    var token = ++photoToken;
    side.src = url;
    side.style.visibility = "visible";
    side.style.transition = "none";
    photo.style.transition = "none";
    side.style.transform = "translate3d(" + dir * width + "px,0,0)";
    photo.style.transform = "translate3d(0,0,0)";
    side.offsetWidth;
    photoAnimating = true;
    var motion = "transform 480ms " + EASE;
    photo.style.transition = motion;
    side.style.transition = motion;
    photo.style.transform = "translate3d(" + -dir * width + "px,0,0)";
    side.style.transform = "translate3d(0,0,0)";
    settleSlide(url, true, token);
  }

  function settleSlide(url, commit, token) {
    var finished = false;
    var done = function () {
      if (finished || token !== photoToken) return;
      finished = true;
      if (commit) photo.src = url;
      photo.style.transition = "none";
      side.style.transition = "none";
      photo.style.transform = "translate3d(0,0,0)";
      side.style.visibility = "hidden";
      side.style.transform = "translate3d(0,0,0)";
      photoAnimating = false;
    };
    photo.addEventListener("transitionend", done, { once: true });
    window.setTimeout(done, 560);
  }

  function clearSlide() {
    photoToken += 1;
    photoAnimating = false;
    photo.style.transition = "none";
    photo.style.transform = "translate3d(0,0,0)";
    if (!side) return;
    side.style.transition = "none";
    side.style.visibility = "hidden";
    side.style.transform = "translate3d(0,0,0)";
  }

  function optionNames(product) {
    return (product.options || []).map(function (option) {
      return typeof option === "string" ? option : (option && option.name) || "";
    });
  }

  function optionValue(variant, idx) {
    if (idx === 0) return variant.option1;
    if (idx === 1) return variant.option2;
    if (idx === 2) return variant.option3;
    return "";
  }

  function renderSizes(product) {
    var names = optionNames(product);
    var sizeIdx = names.findIndex(function (name) { return /size/i.test(name); });
    var colorIdx = names.findIndex(function (name) { return /colou?r/i.test(name); });
    if (sizeIdx < 0) sizeIdx = colorIdx === 0 && names.length > 1 ? 1 : 0;
    var colors = [];
    if (colorIdx >= 0) {
      (product.variants || []).forEach(function (variant) {
        var color = optionValue(variant, colorIdx);
        if (color && colors.indexOf(color) < 0) colors.push(color);
      });
    }
    if (!selectedColor || colors.indexOf(selectedColor) < 0) selectedColor = colors[0] || "";
    if (colorsEl) {
      colorsEl.replaceChildren();
      if (colors.length > 1) {
        colors.forEach(function (color) {
          var chip = document.createElement("button");
          chip.type = "button";
          chip.textContent = color;
          chip.className = color === selectedColor ? "is-active" : "";
          chip.addEventListener("click", function () {
            selectedColor = color;
            renderSizes(product);
          });
          colorsEl.appendChild(chip);
        });
      }
    }
    var seen = {};
    selectedVariant = null;
    if (addBtn) addBtn.hidden = true;
    sizesEl.replaceChildren();
    (product.variants || []).forEach(function (variant) {
      if (selectedColor && colorIdx >= 0 && optionValue(variant, colorIdx) !== selectedColor) return;
      var label = optionValue(variant, sizeIdx) || variant.title;
      if (!label || label === "Default Title") label = "One size";
      if (seen[label]) return;
      seen[label] = true;
      var button = document.createElement("button");
      button.type = "button";
      button.textContent = label;
      if (!variant.available) button.disabled = true;
      button.addEventListener("click", function () {
        if (button.disabled) return;
        selectedVariant = variant.id;
        sizesEl.querySelectorAll("button").forEach(function (other) {
          other.classList.toggle("is-selected", other === button);
        });
        if (addBtn) addBtn.hidden = false;
      });
      sizesEl.appendChild(button);
    });
  }

  var fitCache = {};

  function renderFit(handle) {
    var men = baseHandle(handle);
    var women = men + "-wmns";
    function apply(ok) {
      fitCache[women] = ok;
      fitEl.hidden = !ok;
      if (!ok) return;
      var active = /-wmns$/.test(handle) ? "women" : "men";
      fitEl.querySelectorAll("[data-yz-fit-link]").forEach(function (link) {
        var which = link.getAttribute("data-yz-fit-link");
        link.classList.toggle("is-active", which === active);
        link.setAttribute("href", "/products/" + (which === "women" ? women : men));
      });
    }
    if (Object.prototype.hasOwnProperty.call(fitCache, women)) {
      apply(fitCache[women]);
      return;
    }
    if (initialWomen && initialWomen === women) {
      apply(true);
      return;
    }
    fitEl.hidden = true;
    fetch("/products/" + women + ".js", { headers: { Accept: "application/json" } })
      .then(function (response) {
        apply(response.ok);
      })
      .catch(function () {
        apply(false);
      });
  }

  function paint(product, animate) {
    clearSlide();
    var zoomBox = document.querySelector(".yz-lightbox");
    if (zoomBox) zoomBox.hidden = true;
    document.documentElement.classList.remove("yz-zoom-open");
    current = product;
    imageIndex = 0;
    var imgs = imagesOf(product);
    var stage = root.querySelector(".yz-stage");
    var buy = root.querySelector(".yz-buy");
    var apply = function () {
      if (imgs[0]) photo.src = sized(imgs[0]);
      photo.alt = product.title || "";
      if (nameEl) nameEl.textContent = product.title || "";
      setPrices(product);
      renderDots(product);
      selectedColor = "";
      renderSizes(product);
      descEl.innerHTML = product.description || product.body_html || "";
      renderFit(product.handle);
      renderColorways(product);
      document.title = (product.title || "") + " – DONT DIE";
      warm(product);
    };
    if (!animate) {
      apply();
      return;
    }
    var dir = animate;
    var nodes = [stage, buy];
    Promise.all(
      nodes.map(function (el) {
        return el.animate(
          [
            { opacity: 1, transform: "translateX(0)" },
            { opacity: 0, transform: "translateX(" + dir * -36 + "px)" },
          ],
          { duration: 220, easing: "cubic-bezier(0.4, 0, 1, 1)", fill: "forwards" }
        ).finished;
      })
    ).then(function () {
      apply();
      return Promise.all(
        nodes.map(function (el) {
          return el.animate(
            [
              { opacity: 0, transform: "translateX(" + dir * 36 + "px)" },
              { opacity: 1, transform: "translateX(0)" },
            ],
            { duration: 420, easing: EASE, fill: "forwards" }
          ).finished;
        })
      );
    }).then(function () {
      nodes.forEach(function (el) {
        el.getAnimations().forEach(function (anim) {
          anim.cancel();
        });
      });
    });
  }

  function showPhoto(delta) {
    if (!current || photoAnimating) return;
    var imgs = imagesOf(current);
    if (imgs.length < 2) return;
    imageIndex = (imageIndex + delta + imgs.length) % imgs.length;
    slidePhoto(imgs[imageIndex], delta);
    renderDots(current);
  }

  function catalogIndex(handle) {
    var key = baseHandle(handle);
    var found = catalog.findIndex(function (product) {
      return product.handle === key || product.handle === handle;
    });
    return found;
  }

  function go(delta) {
    if (sliding || !catalog.length || !current) return;
    var at = catalogIndex(current.handle);
    if (at < 0) at = 0;
    var next = catalog[(at + delta + catalog.length) % catalog.length];
    if (!next || next.handle === current.handle) return;
    sliding = true;
    paint(next, delta);
    history.pushState({ handle: next.handle }, "", "/products/" + next.handle + window.location.search);
    window.setTimeout(function () {
      sliding = false;
    }, 660);
  }

  function showProduct(handle, delta) {
    if (current && current.handle === handle) return Promise.resolve(false);
    var inCatalog = catalog.find(function (product) {
      return product.handle === handle;
    });
    var task = inCatalog
      ? Promise.resolve(inCatalog)
      : fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } }).then(function (response) {
          if (!response.ok) throw new Error("missing");
          return response.json();
        });
    return task
      .then(function (product) {
        paint(product, delta || 0);
        return true;
      })
      .catch(function () {
        return false;
      });
  }

  function refreshDrawer() {
    var section = document.querySelector('[id*="header_section"]');
    var sectionId = section && section.id.indexOf("shopify-section-") === 0
      ? section.id.replace("shopify-section-", "")
      : "";
    var fresh = sectionId
      ? fetch(window.location.pathname + "?section_id=" + encodeURIComponent(sectionId)).then(function (response) {
          return response.text();
        })
      : Promise.resolve("");
    return fresh.then(function (html) {
      if (!html) return hoistCart();
      var holder = document.createElement("div");
      holder.innerHTML = html;
      var next = holder.querySelector("cart-drawer-component");
      var prev = document.querySelector("cart-drawer-component");
      if (next && prev) prev.replaceWith(next);
      return document.querySelector("cart-drawer-component");
    });
  }

  function addVariant(id, button) {
    noteEl.hidden = true;
    button.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: id, quantity: 1 }),
    })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw new Error(body.description || body.message || "Could not add that size.");
          return body;
        });
      })
      .then(function () {
        return refreshDrawer();
      })
      .then(function (drawer) {
        if (drawer && typeof drawer.open === "function") {
          window.requestAnimationFrame(function () {
            drawer.open();
          });
        }
        return fetch("/cart.js", { headers: { Accept: "application/json" } });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var count = root.querySelector(".yz-cart-count");
        if (!count && cart.item_count > 0) {
          count = document.createElement("span");
          count.className = "yz-cart-count";
          root.querySelector("[data-yz-cart]").appendChild(count);
        }
        if (count) count.textContent = cart.item_count > 0 ? String(cart.item_count) : "";
      })
      .catch(function (err) {
        noteEl.hidden = false;
        noteEl.textContent = err.message || "Could not add that size.";
      })
      .finally(function () {
        button.disabled = false;
      });
  }

  function loadCatalog() {
    var handle = root.dataset.catalog;
    var page = 1;
    var products = [];
    function next() {
      return fetch("/collections/" + encodeURIComponent(handle) + "/products.json?limit=250&page=" + page)
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          var batch = data.products || [];
          products = products.concat(batch);
          if (batch.length < 250 || page >= 8) return products;
          page += 1;
          return next();
        });
    }
    return next().then(function (list) {
      catalog = handle === "jewlery"
        ? list
        : list.filter(function (product) {
            var title = String(product.title || "").toLowerCase();
            var type = String(product.product_type || "").toLowerCase();
            if (/jewel|accessor/.test(type)) return false;
            return !/\b(bracelet|earrings?|necklace|hair\s?clips?|hairclip|headband|bangle)\b/.test(title);
          });
      if (current) renderColorways(current);
    });
  }

  function colorwayParts(product) {
    var title = String((product && product.title) || "").trim();
    var match = title.match(/^(.*\S)\s+\(([A-Za-z]{3})\)$/);
    if (!match) return null;
    return {
      base: match[1].replace(/\s+/g, " ").toUpperCase(),
      code: match[2].toUpperCase(),
      fit: /-wmns$/.test(product.handle || "") ? "w" : "m"
    };
  }

  function renderColorways(product) {
    var box = root.querySelector("[data-yz-colorways]");
    var row = root.querySelector("[data-yz-colorways-row]");
    if (!box || !row) return;
    row.replaceChildren();
    var mine = product && colorwayParts(product);
    var others = [];
    if (mine && catalog.length) {
      others = catalog.filter(function (item) {
        if (!item || item.handle === product.handle) return false;
        var parts = colorwayParts(item);
        return parts && parts.base === mine.base && parts.fit === mine.fit && parts.code !== mine.code;
      });
      others.sort(function (a, b) {
        return String(a.title || "").localeCompare(String(b.title || ""));
      });
    }
    others.forEach(function (item) {
      var parts = colorwayParts(item);
      var link = document.createElement("a");
      link.href = "/products/" + item.handle;
      link.title = parts ? parts.code : item.title || "";
      link.setAttribute("aria-label", item.title || "Other colorway");
      var src = imagesOf(item)[0] || "";
      if (src) {
        var img = document.createElement("img");
        img.alt = "";
        img.src = sized(src).replace("width=1400", "width=320");
        link.appendChild(img);
      } else if (parts) {
        link.textContent = parts.code;
      }
      link.addEventListener("click", function (event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        showProduct(item.handle, 0).then(function (ok) {
          if (ok) history.pushState({ handle: item.handle }, "", "/products/" + item.handle + window.location.search);
        });
      });
      row.appendChild(link);
    });
    box.hidden = others.length === 0;
  }

  root.querySelector("[data-yz-prev]").addEventListener("click", function () {
    showPhoto(-1);
  });
  root.querySelector("[data-yz-next]").addEventListener("click", function () {
    showPhoto(1);
  });

  function bindLightbox() {
    var box = document.createElement("div");
    box.className = "yz-lightbox";
    box.hidden = true;
    box.innerHTML =
      '<button type="button" class="yz-lightbox-close" aria-label="Close">\u00d7</button>' +
      '<div class="yz-lightbox-stage">' +
      '<img class="yz-lightbox-photo" alt="">' +
      '<img class="yz-lightbox-side" alt="" aria-hidden="true">' +
      "</div>";
    document.body.appendChild(box);
    var stage = box.querySelector(".yz-lightbox-stage");
    var main = box.querySelector(".yz-lightbox-photo");
    var next = box.querySelector(".yz-lightbox-side");
    var closeBtn = box.querySelector(".yz-lightbox-close");
    var scale = 1;
    var panX = 0;
    var panY = 0;
    var pointers = {};
    var swipeDx = 0;
    var swipeDir = 0;
    var swiping = false;
    var pinching = false;
    var pinchDist = 1;
    var pinchScale = 1;
    var gestureMoved = false;
    var originX = 0;
    var originY = 0;
    var originPanX = 0;
    var originPanY = 0;
    var lastTap = 0;
    var animating = false;

    function placed(el, dx) {
      el.style.transform = "translate(calc(-50% + " + dx + "px), -50%)";
    }

    function renderZoom() {
      main.style.transform =
        "translate(calc(-50% + " + panX + "px), calc(-50% + " + panY + "px)) scale(" + scale + ")";
    }

    function clampPan() {
      var maxX = Math.max(0, (main.offsetWidth * scale - stage.clientWidth) / 2);
      var maxY = Math.max(0, (main.offsetHeight * scale - stage.clientHeight) / 2);
      panX = Math.max(-maxX, Math.min(maxX, panX));
      panY = Math.max(-maxY, Math.min(maxY, panY));
    }

    function resetZoom() {
      scale = 1;
      panX = 0;
      panY = 0;
      swiping = false;
      main.style.transition = "none";
      next.style.transition = "none";
      next.style.visibility = "hidden";
      renderZoom();
    }

    function openZoom() {
      if (!current) return;
      var imgs = imagesOf(current);
      if (!imgs.length) return;
      main.src = sized(imgs[imageIndex]);
      main.alt = photo.alt || "";
      resetZoom();
      box.hidden = false;
      document.documentElement.classList.add("yz-zoom-open");
    }

    function closeZoom() {
      box.hidden = true;
      document.documentElement.classList.remove("yz-zoom-open");
      pointers = {};
      pinching = false;
      swiping = false;
      animating = false;
      resetZoom();
    }

    function pointerList() {
      return Object.keys(pointers).map(function (id) {
        return pointers[id];
      });
    }

    function span(list) {
      var dx = list[0].x - list[1].x;
      var dy = list[0].y - list[1].y;
      return Math.sqrt(dx * dx + dy * dy) || 1;
    }

    function finishSwipe() {
      var width = stage.clientWidth || 1;
      var imgs = imagesOf(current);
      var passed = Math.abs(swipeDx) > Math.max(56, width * 0.18);
      if (!passed || !imgs || imgs.length < 2) {
        main.style.transition = "transform 320ms " + EASE;
        next.style.transition = "transform 320ms " + EASE;
        placed(main, 0);
        placed(next, (swipeDir || 1) * width);
        window.setTimeout(function () {
          animating = false;
          resetZoom();
        }, 340);
        return;
      }
      imageIndex = (imageIndex + swipeDir + imgs.length) % imgs.length;
      var url = sized(imgs[imageIndex]);
      main.style.transition = "transform 480ms " + EASE;
      next.style.transition = "transform 480ms " + EASE;
      placed(main, -swipeDir * width);
      placed(next, 0);
      window.setTimeout(function () {
        main.src = url;
        photo.src = url;
        renderDots(current);
        animating = false;
        resetZoom();
      }, 500);
    }

    closeBtn.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      closeZoom();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !box.hidden) closeZoom();
    });

    stage.addEventListener("pointerdown", function (event) {
      if (box.hidden || animating) return;
      if (event.pointerType === "mouse" && event.button !== 0) return;
      pointers[event.pointerId] = { x: event.clientX, y: event.clientY };
      var list = pointerList();
      if (list.length >= 2) {
        pinching = true;
        swiping = false;
        pinchDist = span(list);
        pinchScale = scale;
        next.style.visibility = "hidden";
        return;
      }
      gestureMoved = false;
      originX = event.clientX;
      originY = event.clientY;
      originPanX = panX;
      originPanY = panY;
      swiping = false;
      swipeDx = 0;
    });

    stage.addEventListener("pointermove", function (event) {
      if (!pointers[event.pointerId] || box.hidden) return;
      pointers[event.pointerId] = { x: event.clientX, y: event.clientY };
      var list = pointerList();
      if (list.length >= 2 && pinching) {
        scale = Math.max(1, Math.min(4, pinchScale * (span(list) / pinchDist)));
        if (scale <= 1.02) {
          scale = 1;
          panX = 0;
          panY = 0;
        }
        clampPan();
        main.style.transition = "none";
        renderZoom();
        gestureMoved = true;
        return;
      }
      if (pinching) return;
      var dx = event.clientX - originX;
      var dy = event.clientY - originY;
      if (Math.abs(dx) > 8 || Math.abs(dy) > 8) gestureMoved = true;
      if (scale > 1.02) {
        panX = originPanX + dx;
        panY = originPanY + dy;
        clampPan();
        main.style.transition = "none";
        renderZoom();
        return;
      }
      var imgs = imagesOf(current);
      if (!imgs || imgs.length < 2) return;
      if (!swiping) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        if (Math.abs(dy) > Math.abs(dx)) return;
        swiping = true;
        animating = true;
        swipeDir = dx < 0 ? 1 : -1;
        next.src = sized(imgs[(imageIndex + swipeDir + imgs.length) % imgs.length]);
        next.style.visibility = "visible";
        next.style.transition = "none";
        main.style.transition = "none";
      }
      if ((dx < 0 ? 1 : -1) !== swipeDir && Math.abs(dx) > 12) {
        swipeDir = dx < 0 ? 1 : -1;
        var turned = imagesOf(current);
        next.src = sized(turned[(imageIndex + swipeDir + turned.length) % turned.length]);
      }
      swipeDx = dx;
      placed(main, dx);
      placed(next, dx + swipeDir * (stage.clientWidth || 1));
    });

    function endPointer(event) {
      if (!pointers[event.pointerId]) return;
      delete pointers[event.pointerId];
      if (pointerList().length < 2) pinching = false;
      if (pointerList().length > 0) return;
      if (swiping) {
        swiping = false;
        finishSwipe();
        return;
      }
      if (gestureMoved || animating || box.hidden) return;
      var now = Date.now();
      if (now - lastTap < 280) {
        scale = scale > 1.05 ? 1 : 2;
        if (scale === 1) {
          panX = 0;
          panY = 0;
        }
        clampPan();
        main.style.transition = "transform 280ms " + EASE;
        renderZoom();
        lastTap = 0;
        return;
      }
      lastTap = now;
    }

    stage.addEventListener("pointerup", endPointer);
    stage.addEventListener("pointercancel", endPointer);
    return openZoom;
  }

  (function bindPhotoSwipe() {
    var startX = 0;
    var startY = 0;
    var dragDx = 0;
    var dragDir = 0;
    var dragging = false;
    var tracking = false;
    var moved = false;
    var openZoom = bindLightbox();

    function widthOf() {
      return photo.getBoundingClientRect().width;
    }

    function place(dx, dir, width) {
      photo.style.transform = "translate3d(" + dx + "px,0,0)";
      side.style.transform = "translate3d(" + (dx + dir * width) + "px,0,0)";
    }

    function snapBack() {
      var width = widthOf();
      var token = photoToken;
      photoAnimating = true;
      var motion = "transform 320ms " + EASE;
      photo.style.transition = motion;
      side.style.transition = motion;
      place(0, dragDir || 1, width);
      settleSlide(photo.src, false, token);
    }

    function finishDrag() {
      if (!dragging) return;
      dragging = false;
      var width = widthOf();
      var passed = Math.abs(dragDx) > Math.max(56, width * 0.18);
      if (!passed) {
        snapBack();
        return;
      }
      var imgs = imagesOf(current);
      imageIndex = (imageIndex + dragDir + imgs.length) % imgs.length;
      var url = sized(imgs[imageIndex]);
      var token = ++photoToken;
      photoAnimating = true;
      var motion = "transform 480ms " + EASE;
      photo.style.transition = motion;
      side.style.transition = motion;
      photo.style.transform = "translate3d(" + -dragDir * width + "px,0,0)";
      side.style.transform = "translate3d(0,0,0)";
      settleSlide(url, true, token);
      renderDots(current);
    }

    frame.addEventListener("pointerdown", function (event) {
      if (photoAnimating || !current) return;
      if (event.pointerType === "mouse" && event.button !== 0) return;
      tracking = true;
      dragging = false;
      moved = false;
      dragDir = 0;
      dragDx = 0;
      startX = event.clientX;
      startY = event.clientY;
    });

    frame.addEventListener("pointermove", function (event) {
      if (!tracking) return;
      if (photoAnimating && !dragging) return;
      var dx = event.clientX - startX;
      var dy = event.clientY - startY;
      if (Math.abs(dx) > 10 || Math.abs(dy) > 10) moved = true;
      var imgs = imagesOf(current);
      if (!imgs || imgs.length < 2) return;
      if (!dragging) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        if (Math.abs(dy) > Math.abs(dx)) {
          tracking = false;
          return;
        }
        dragging = true;
        photoAnimating = true;
        dragDir = dx < 0 ? 1 : -1;
        if (frame.setPointerCapture) frame.setPointerCapture(event.pointerId);
        var nextIndex = (imageIndex + dragDir + imgs.length) % imgs.length;
        side.src = sized(imgs[nextIndex]);
        side.style.visibility = "visible";
        photo.style.transition = "none";
        side.style.transition = "none";
      }
      if (dragDir && (dx < 0 ? 1 : -1) !== dragDir && Math.abs(dx) > 12) {
        dragDir = dx < 0 ? 1 : -1;
        var turned = imagesOf(current);
        var nextIndex = (imageIndex + dragDir + turned.length) % turned.length;
        side.src = sized(turned[nextIndex]);
      }
      dragDx = dx;
      place(dx, dragDir, widthOf());
    });

    frame.addEventListener("pointerup", function () {
      if (!tracking) return;
      tracking = false;
      if (dragging) {
        finishDrag();
        return;
      }
      if (!moved) openZoom();
    });

    frame.addEventListener("pointercancel", function () {
      if (!tracking) return;
      tracking = false;
      if (dragging) snapBack();
      dragging = false;
    });
  })();
  root.querySelector("[data-yz-next-product]").addEventListener("click", function () {
    go(1);
  });

  fitEl.querySelectorAll("[data-yz-fit-link]").forEach(function (link) {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      var handle = link.getAttribute("href").split("/products/")[1];
      var delta = link.getAttribute("data-yz-fit-link") === "women" ? 1 : -1;
      showProduct(handle, delta).then(function (ok) {
        if (ok) history.pushState({ handle: handle }, "", "/products/" + handle + window.location.search);
      });
    });
  });

  if (addBtn) {
    addBtn.addEventListener("click", function () {
      if (!selectedVariant) return;
      addVariant(selectedVariant, addBtn);
    });
  }

  var cart = root.querySelector("[data-yz-cart]");
  if (cart) {
    cart.addEventListener("click", function (event) {
      var drawer = hoistCart();
      if (!drawer || typeof drawer.open !== "function") return;
      event.preventDefault();
      event.stopPropagation();
      window.requestAnimationFrame(function () {
        drawer.open();
      });
    });
  }

  window.addEventListener("popstate", function () {
    var handle = window.location.pathname.split("/products/")[1];
    if (handle) showProduct(decodeURIComponent(handle.split("?")[0]), 0);
  });

  current = readInitial();
  if (current) {
    setPrices(current);
    renderDots(current);
    renderSizes(current);
    renderFit(current.handle);
    warm(current);
  }
  hoistCart();
  loadCatalog();
})();
